var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-category"},[_c('p',{staticClass:"text-2xl"},[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('p',[_vm._v(_vm._s(_vm.subtitle))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }